<template>
  <div
    class="event"
    @click="$emit('click')">
    <div class="event__category">
      {{ event.category.name }}
    </div>
    <div
      class="event__color"
      :style="{ backgroundColor: event.color }" />
    
    <div class="event__stamp">
      <event-stamp
        v-if="event.icon"
        :value="event.icon" />
    </div>
    <div
      class="event__title">
      {{ event.title }}
    </div>
    
    <div class="event-badges">
      <div
        class="event-badges__draft">
        <div
          v-if="isDraft"
          class="event-badge__draft">
          下書き
        </div>
      </div>
      <div class="event-badges__file">
        <span
          v-if="hasFile"
          class="material-icons">
          description
        </span>
      </div>
    </div>
  </div> 
</template>

<script>
import format from 'date-fns/format'
import EventStamp from '@/components/parts/EventStamp.vue'
export default {
  components: {
    EventStamp
  },
  props: {
    event: {
      type: Object,
      required: true
    },
  },
  computed: {
    dateTime() {
      if (this.event.isAllDay) {
        return '終日'
      }
      const startAt = new Date(this.event.startAt)
      const endAt = new Date(this.event.endAt)
      return `${format(startAt, 'HH:mm')}~${format(endAt, 'HH:mm')}`
    },
    isDraft() {
      return this.event.isDraft
    },
    hasFile() {
      return this.event.file !== null
    },
  },
}
</script>

<style lang="scss" scoped>
.event {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  &__category {
    width: 50px;
    min-width: 50px;
    font-size: 12px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  &__color {
    width: 8px;
    min-width: 8px;
    height: 16px;
  }

  &__title {
    padding-left: 8px;
    font-size: 14px;
    font-weight: 700;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  &__stamp {
    margin-left: 8px;
  }

  &-badges {
    max-width: 128px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-left: auto;

    &__draft {
      width: 40px;
      margin-right: 4px;
    }

    &__file {
      width: 24px;
      height: 24px;
      text-align: center;
      font-size: 10px;
    }
  }

  &-badge {
    &__draft {
      width: 40px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #FFFFFF;
      font-size: 10px;
      background-color: #302C2C;
      margin-right: 4px;
    }
  }

}
</style>